import React from "react";
import PropTypes from "prop-types";

class ThanksgivingChrome extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props.savedState;
  }

  componentDidMount() {
    this.setState({ turkey: "gobble gobble" });
  }

  componentWillUnmount() {
    this.props.saveState(this.state);
  }

  render() {
    return (
      <span>
        <div id="thanksgiving-chrome">
          <div id="some-random-tg-container">{this.props.children}</div>
        </div>
        <img src="/img/thanksgiving/assets/frame.png" id="thanksgiving-frame" />
      </span>
    );
  }
}

ThanksgivingChrome.propTypes = {
  saveState: PropTypes.object,
  children: PropTypes.element
};

ThanksgivingChrome.defaultProps = {
  saveState: {}
};

module.exports = {
  class: ThanksgivingChrome,
  metadata: () => {
    return {
      id: "thanksgiving",
      name: i18n.t("scratchpad.scratchpad"),
      description: i18n.t("scratchpad.description"),
      type: "chrome"
    };
  }
};
